import { setStringToStorage, setObjectToStorage, getStringFromStorage } from "./storagehelper";
import { ProfileSettings } from "../types/app.storage.enums";
import { UserPreferenceService } from "../service/UserPreferenceService";
import { SheetOptionService } from "../service/SheetOptionService";
import { ProfileService } from "../service/ProfileService";

const userPreferenceService = new UserPreferenceService();

const toFlagString = (value) => (String(value).toLowerCase() === "true" ? "true" : "false");

const getLicenseValue = (result, ...keys) => {
  if (!result || typeof result !== "object") {
    return "false";
  }
  for (const key of keys) {
    if (result[key] !== undefined && result[key] !== null) {
      return toFlagString(result[key]);
    }
  }
  return "false";
};

export const isLicenseFlagEnabled = (key: string) => toFlagString(getStringFromStorage(key)) === "true";

export const saveLicenseDetails = (profileid) => {
  return userPreferenceService.getLicences(profileid).then((result) => {
    const license = Array.isArray(result) ? result[0] : result?.data ?? result;
    if (license) {
      setStringToStorage(
        ProfileSettings.LicenseFlag,
        getLicenseValue(license, "isFundsConsoleLicensed", "IsFundsConsoleLicensed")
      );
      setStringToStorage(
        ProfileSettings.AnalyticalLicenseFlag,
        getLicenseValue(license, "isAdvancedAnalyticsLicensed", "IsAdvancedAnalyticsLicensed")
      );
      setStringToStorage(
        ProfileSettings.UniversalAnalyticsFlag,
        getLicenseValue(
          license,
          "isUniverserAnalyticsLicensed",
          "isUniverseAnalyticsLicensed",
          "IsUniverserAnalyticsLicensed",
          "IsUniverseAnalyticsLicensed"
        )
      );
      setStringToStorage(
        ProfileSettings.IsBasicAccessToAssetAndOrganizationsLicensed,
        getLicenseValue(
          license,
          "isBasicAccessToAssetAndOrganizationsLicensed",
          "IsBasicAccessToAssetAndOrganizationsLicensed"
        )
      );
      setStringToStorage(
        ProfileSettings.IsUniverseAnalyticsDownloadAllowed,
        getLicenseValue(license, "isUniverseAnalyticsDownloadAllowed", "IsUniverseAnalyticsDownloadAllowed")
      );
    }
  });
};

export const saveCustomFieldMasterData = (profileid) => {
  return userPreferenceService.getCustomFieldMasterData(profileid).then((result) => {
    if (result) setObjectToStorage(ProfileSettings.LstGetFunctionCustomAttributeName, result);
  });
};

export const savePmeIndex = (profileid) => {
  return userPreferenceService.getPmeIndexes(profileid).then((result) => {
    if (result) setObjectToStorage(ProfileSettings.LstPmeIndex, result);
  });
};

export const saveMeasurementDates = (profileid) => {
  return userPreferenceService.getMeasurement(profileid).then((result) => {
    if (result) setObjectToStorage(ProfileSettings.DtMeasurement, result);
  });
};

export const saveCurrency = (profileid) => {
  return userPreferenceService.getCurrency(profileid).then((result) => {
    if (result) setObjectToStorage(ProfileSettings.DtCurrencies, result);
  });
};

export const saveAlternateBaseCurrency = (profileid) => {
  return userPreferenceService.getAlternateBaseCurrency(profileid).then((result) => {
    if (result) setObjectToStorage(ProfileSettings.DtAlrternateBaseCurrencies, result);
  });
};

export const saveCurrencyHedge = (profileid) => {
  return new SheetOptionService().getCurrencyHedge(profileid).then((result) => {
    if (result) setObjectToStorage(ProfileSettings.CurrencyHedgeList, result);
  });
};

export const getProfileFromStorage = async () => {
  return await new ProfileService().getProfiles().then((profile) => {
    const profileID = getStringFromStorage(ProfileSettings.ProfileId);
    const selectedProfile = profile.filter((item) => {
      return item.profileID === profileID;
    });
    return selectedProfile ? selectedProfile[0] : null;
  });
};
